"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _default = function _default() {
  return new _immutable.List([{
    name: _I18n.default.text('timezone_utils.timezones.pacific_time'),
    timezones: ['US/Pacific', 'America/Los_Angeles']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.mountain_time'),
    timezones: ['US/Mountain', 'America/Denver']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.central_time'),
    timezones: ['US/Central', 'America/Chicago']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.central_standard_time'),
    timezones: ['America/Guatemala']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.eastern_time'),
    timezones: ['US/Eastern', 'America/New_York']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.atlantic_time'),
    timezones: ['Canada/Atlantic']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.central_european_time_europe'),
    timezones: ['Europe/Berlin']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.central_european_time_africa'),
    timezones: ['Africa/Lagos']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.eastern_european_time'),
    timezones: ['Europe/Athens']
  }, {
    name: _I18n.default.formatList([_I18n.default.text('timezone_utils.cities.dublin'), _I18n.default.text('timezone_utils.cities.london'), _I18n.default.text('timezone_utils.cities.lisbon')]),
    timezones: ['Europe/Dublin']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.eastern_caribbean_time'),
    timezones: ['America/Barbados']
  }, {
    name: _I18n.default.formatList([_I18n.default.text('timezone_utils.countries.china'), _I18n.default.text('timezone_utils.cities.hong_kong'), _I18n.default.text('timezone_utils.cities.singapore')]),
    timezones: ['Asia/Shanghai']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.greenwich_mean_time'),
    timezones: ['Africa/Timbuktu']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.argentinian_time'),
    timezones: ['America/Argentina/Buenos_Aires']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.south_africa_time'),
    timezones: ['Africa/Johannesburg']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.east_africa_time'),
    timezones: ['Africa/Nairobi']
  }, {
    name: _I18n.default.formatList([_I18n.default.text('timezone_utils.cities.jamaica'), _I18n.default.text('timezone_utils.cities.panama'), _I18n.default.text('timezone_utils.cities.colombia')]),
    timezones: ['America/Jamaica']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.indochina_time'),
    timezones: ['Asia/Bangkok']
  }, {
    name: _I18n.default.formatList([_I18n.default.text('timezone_utils.cities.new_delhi'), _I18n.default.text('timezone_utils.cities.mumbai'), _I18n.default.text('timezone_utils.cities.calcutta')]),
    timezones: ['Asia/Calcutta']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.arizona_time'),
    timezones: ['America/Phoenix']
  }, {
    name: _I18n.default.text('timezone_utils.timezones.ae_time'),
    timezones: ['Australia/Canberra']
  }, {
    name: _I18n.default.formatList([_I18n.default.text('timezone_utils.cities.baghdad'), _I18n.default.text('timezone_utils.cities.bahrain'), _I18n.default.text('timezone_utils.cities.istanbul'), _I18n.default.text('timezone_utils.cities.qatar')]),
    timezones: ['Asia/Baghdad']
  }, {
    name: _I18n.default.formatList([_I18n.default.text('timezone_utils.cities.seoul'), _I18n.default.text('timezone_utils.cities.tokyo')]),
    timezones: ['Asia/Seoul']
  }]);
};

exports.default = _default;
module.exports = exports.default;